import {pixel} from '@packages/utilities/inline-style-utils';

export function getCheckboxSize({theme: {checkbox}, sizing}: any) {
  const multiplier = sizing === 'large' ? 16 / 12 : 1;
  const size = pixel(multiplier * checkbox.size);

  return {
    width: size,
    height: size,
  };
}

export const checkboxStyle = ({theme: {control, checkbox}, sizing}: any) => ({
  ...getCheckboxSize({theme: {checkbox}, sizing}),
  alignItems: 'center',
  background: checkbox.background.normal,
  borderColor: checkbox.borderColor.normal,
  borderRadius: checkbox.borderRadius,
  borderStyle: 'solid',
  borderWidth: control.borderWidth,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
});

export const checkboxStyleVariations = {
  keyboardFocus: ({theme: {checkbox, focusColors}}: any) => ({
    borderColor: 'transparent',
    boxShadow: focusColors.outline,
    background: checkbox.background.focus,
  }),
  disabled: () => ({
    cursor: 'not-allowed',
    opacity: 0.5,
  }),
  // Variant to render disabled UI, without rendering the `disabled` attribute
  // into the HTML.
  isDisabled: () => ({
    cursor: 'not-allowed',
    opacity: 0.5,
  }),
  label: ({theme}: any) => ({
    marginRight: theme.gutters.normal,
  }),
  labelled: ({theme}: any) => ({
    marginRight: theme.gutters.normal,
  }),
  checked: ({theme: {checkbox}}: any) => ({
    borderColor: checkbox.borderColor.checked,
    background: checkbox.background.checked,
  }),
  dashed: ({theme: {checkbox}}: any) => ({
    borderColor: checkbox.borderColor.checked,
    background: checkbox.background.checked,
  }),
  accent: ({theme: {checkbox}, checked}: any) => ({
    borderColor: checked
      ? checkbox.borderColor.accent
      : checkbox.borderColor.checked,
  }),
  intent: ({theme: {colors}}: any) => ({
    background: colors.accentBackground,
    borderColor: colors.accentBackground,
  }),
} as const;

export const checkmarkStyle = ({
  checked,
  dashed,
  hover,
  showPreviewCheck,
}: any) => ({
  bottom: 0, // Adjusts position for checked icon
  display: checked || dashed || hover || showPreviewCheck ? 'block' : 'none',
});

export const checkmarkStyleVariations = {
  hover: ({theme: {checkbox}}: any) => ({
    color: checkbox.color.hover,
  }),
  checked: ({theme: {checkbox}}: any) => ({
    color: checkbox.color.checked,
  }),
  dashed: ({theme: {checkbox}}: any) => ({
    bottom: 0,
    color: checkbox.color.dashed,
  }),
  accent: ({theme: {checkbox}, checked}: any) => ({
    color: checked ? checkbox.color.accent : checkbox.color.hover,
  }),
  showPreviewCheck: ({theme: {checkbox}, checked}: any) => ({
    color: checked ? checkbox.color.checked : checkbox.color.hover,
  }),
} as const;
